import { Modal, ModalProps } from '@mui/material';

export const ACGModal = (props: ModalProps) => {
  return (
    <Modal {...props} style={{ overflowY: 'scroll' }}>
      <div>{props.children}</div>
    </Modal>
  );
};
